import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {usePrettyFileSize} from "../../../lib/files/usePrettyFileSize";
import * as XLSX from "xlsx";

type UseFileSelectArgs = {
    allowedTypes?: string[];
}

export const useFileSelect = ({
                                  allowedTypes = [],
                              }: UseFileSelectArgs) => {


    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const activateFileSelect = useCallback(() => {
        if (!fileInputRef.current) return;
        fileInputRef.current.click()

    }, [fileInputRef.current])

    const [selectedFile, setSelectedFile] = useState<File | null>(null)


    const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0] || null;
        setSelectedFile(file);
    }, []);



    const invalidFile = useMemo(() => {
        if (!selectedFile) return false;

        const fileName = selectedFile.name.toLowerCase();

        if (allowedTypes.length == 0) {
            return false
        }

        console.log(allowedTypes, fileName);

        const match = allowedTypes.find(t => fileName.endsWith(`.${t}`))
        return !match

    }, [selectedFile])

    const [fileUrl, setFileUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!selectedFile) {
            setFileUrl(null);
            return;
        }

        const url = URL.createObjectURL(selectedFile);
        setFileUrl(url);

        return () => {
            URL.revokeObjectURL(url); // 🧼 Prevent memory leaks
        };

    }, [selectedFile]);


    const prettyFileSize = usePrettyFileSize(selectedFile);

    const clearFile = useCallback(() => {
        setSelectedFile(null)
    }, [])


    const accept = useMemo(()=>{
        return allowedTypes.map(t => `.${t}`).join(", ")
    }, [allowedTypes])

    return {
        fileInputRef,
        activateFileSelect,
        selectedFile,
        handleFileChange,
        fileUrl,
        prettyFileSize,
        clearFile,
        invalidFile,
        accept,
    }
}

useFileSelect.displayName = "useFileSelect"